import styled from 'styled-components';

export const ResponsiveGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(600px, 1fr)) !important;
	gap: 1rem;
	@media (max-width: 600px) {
		grid-template-columns: 1fr !important;
	}
`;

export const HeaderWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	@media (max-width: 600px) {
		flex-direction: column;
		align-items: flex-start;
		gap: 1rem;
	}
`;

export const AccordionSummaryWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	padding-right: 2rem;
	@media (max-width: 800px) {
		flex-direction: column;
		gap: 1rem;
	}
`;
